import { matchPath } from "react-router";
import { useLocation } from "react-router-dom";
import { useGetRoutesArray } from "../../routes/routes";

export function useCurrentRoute() {
  const routes = useGetRoutesArray();
  const { pathname } = useLocation();

  for (const route of routes) {
    if (matchPath({ path: route.path }, pathname)) {
      return route.path;
    }
  }
}
